/**
 * Limits for vendors and photos stored on a project task.
 * CommonJS. No object spread: functions require this file directly.
 */

const MAX_TASK_VENDORS = 3;
const MAX_TASK_PHOTOS = 12;
const TASK_PHOTO_BUCKET = 'project-task-photos';
const SIGNED_SECONDS = 60 * 60;
const VENDOR_LIMIT_MESSAGE = 'A task can have at most 3 vendors';
const DUPLICATE_VENDOR_MESSAGE = 'A project task cannot list the same vendor twice';

function taskPhotoPath(projectId, taskKey, photoId) {
  return `${String(projectId)}/${String(taskKey)}/${String(photoId)}.jpg`;
}

function vendorSlots(task) {
  const row = task && typeof task === 'object' ? task : {};
  const vendors = Array.isArray(row.vendors) ? row.vendors.length : 0;
  const ids = Array.isArray(row.vendor_ids) ? row.vendor_ids.length : 0;
  return Math.max(vendors, ids);
}

function tasksWithinVendorLimit(tasks) {
  if (!Array.isArray(tasks)) return false;
  for (let index = 0; index < tasks.length; index += 1) {
    if (vendorSlots(tasks[index]) > MAX_TASK_VENDORS) return false;
  }
  return true;
}

function vendorIdentity(vendor) {
  if (!vendor || typeof vendor !== 'object') return '';
  const id = vendor.id == null ? '' : String(vendor.id).trim();
  if (!id) return '';
  const source = vendor.source ? String(vendor.source).trim() : 'agent';
  return `${source}:${id}`;
}

function taskHasDuplicateVendors(task) {
  const row = task && typeof task === 'object' ? task : {};
  const seenVendor = {};
  const vendors = Array.isArray(row.vendors) ? row.vendors : [];
  for (let index = 0; index < vendors.length; index += 1) {
    const key = vendorIdentity(vendors[index]);
    if (!key) continue;
    if (seenVendor[key]) return true;
    seenVendor[key] = true;
  }
  const seenId = {};
  const ids = Array.isArray(row.vendor_ids) ? row.vendor_ids : [];
  for (let index = 0; index < ids.length; index += 1) {
    const id = ids[index] == null ? '' : String(ids[index]).trim();
    if (!id) continue;
    if (seenId[id]) return true;
    seenId[id] = true;
  }
  return false;
}

function tasksHaveDuplicateVendors(tasks) {
  if (!Array.isArray(tasks)) return false;
  for (let index = 0; index < tasks.length; index += 1) {
    if (taskHasDuplicateVendors(tasks[index])) return true;
  }
  return false;
}

module.exports = {
  MAX_TASK_VENDORS,
  MAX_TASK_PHOTOS,
  TASK_PHOTO_BUCKET,
  SIGNED_SECONDS,
  VENDOR_LIMIT_MESSAGE,
  DUPLICATE_VENDOR_MESSAGE,
  taskPhotoPath,
  vendorSlots,
  tasksWithinVendorLimit,
  taskHasDuplicateVendors,
  tasksHaveDuplicateVendors,
};
